<template>

  <div class="btn-group">
    <button
      class="btn btn-secondary dropdown-toggle"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      v-tooltip="'Desqualificar'">
      <i class="fas fa-ban" />
    </button>
    <div
      class="dropdown-menu p-3"
      aria-labelledby="dropdownMenuButton2"
      style="width: 280px"
      @click="$event.stopPropagation()">
      <form v-on:submit.prevent="disqualify">
        <div
          style="overflow: auto; max-height: 200px;">
          <div
            v-for="(item, index) in disqualifyReasons"
            :key="index">
            <label>
              <div class="d-flex">
                <div class="mr-2">
                  <input type="radio" v-model="disqualifyId" :value="item._id">
                </div>
                <div class="flex-grow-1">{{ item.name }}</div>
              </div>
            </label>
          </div>
        </div>
        <div
          class="mt-3"
          v-if="disqualifyId">
          <label class="mb-3">
            <input
              type="checkbox"
              v-model="disqualifyNotification"> {{ $t('Notify candidate') }}
          </label>
          <button
            type="submit"
            class="btn btn-primary btn-block">{{ $t('Save') }}</button>  
        </div>
      </form>
    </div>
  </div>

</template>

<script>
export default {
  name: 'JobActionMassDisqualify',
  components: {
  },
  data () {
    return {
      disqualifyId: false,
      disqualifyNotification: false
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    candidates () {
      return this.$store.getters.getCandidateSelected
    },
    disqualifyReasons () {
      return this.$store.getters.getDisqualifyReasons
    }
  },
  created () {
  },
  methods: {
    /*
    disqualify
    */
    disqualify () {
      this.candidates.forEach((candidate) => {
        const placement = candidate.placements.find(v => v.job_id === this.job._id)
        this.$store.dispatch('disqualifyPlacement', {
          _id: placement._id,
          disqualify_reason_id: this.disqualifyId
        })
      })

      if (this.disqualifyNotification) {
        this.$emit('disqualifyNotification')
      } else {
        this.$store.dispatch('resetCandidateSelected')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobMassiveAction/JobMassiveActionDisqualify.vue